import EventTile from "../../Feed/components/tiles/EventTile"
import { UmbracoNode } from "../../models/UmbracoNode"

export type GroupedEventsModel = {
  defaultImage: string,
  nodes: UmbracoNode[]
}

export default function GroupedEvents({ defaultImage, nodes }: GroupedEventsModel) {
  return (
    <div className="grid-x grid-margin-x small-up-1 medium-up-1 large-up-2 grouped-events">
        { nodes.length > 0 && nodes.map((item) => (
          <EventTile key={`event-${item.id}`} node={item} defaultImage={defaultImage} />
        ))}
    </div>
  )
}